module.exports = __webpack_public_path__ + "img/11_69.b55eaeca.png";